import { Table, TableProps } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { tableLoaderSpin } from './tableLoaderSpin';

const TableStickyContainer = styled.div`
  position: fixed;
  right: 0;
  // left: pageFixedSizes.siderWidht,
  // top: heading.clientRect?.bottom ?? 169,
  left: 0;
  top: 169;
  bottom: 0;
  overflow-y: scroll;
`;

export interface TableStickyProps<T>
  extends Omit<TableProps<T>, 'loading' | 'sticky'> {
  loading?: boolean;
}

/**
 * Tabella Personalizzata con Header Sticky
 */
export function TableSticky<T extends object>(props: TableStickyProps<T>) {
  const { loading, ...otherProps } = props;

  const table = document.getElementById('fixed-table-container');
  const stickyProps = table
    ? ({
        sticky: {
          getContainer: () => table,
        },
      } satisfies Partial<TableProps<T>>)
    : {};

  return (
    <TableStickyContainer>
      <Table<T>
        loading={tableLoaderSpin(loading)}
        {...otherProps}
        size="middle"
        {...stickyProps}
      />
    </TableStickyContainer>
  );
}
